import { render, staticRenderFns } from "./CardUpdatePage.vue?vue&type=template&id=490d460c&scoped=true&"
import script from "./CardUpdatePage.vue?vue&type=script&lang=js&"
export * from "./CardUpdatePage.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdatePage.vue?vue&type=style&index=0&id=490d460c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d460c",
  null
  
)

export default component.exports